import { render } from "./brokerageRule.vue?vue&type=template&id=13d154e9&scoped=true"
import script from "./brokerageRule.vue?vue&type=script&lang=js"
export * from "./brokerageRule.vue?vue&type=script&lang=js"

import "./brokerageRule.vue?vue&type=style&index=0&id=13d154e9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d154e9"]])

export default __exports__